export const API_ERROR_MESSAGE = {
  MAXIMUM_NUMBER_OF_PROMPTS_REACHED: "Maximum number of prompts reached",
  INSUFFICIENT_BALANCE: "Insufficient balance",
};

/**
 * Single source of truth for brand colors.
 *
 * Keep these in sync with `theme.palette` in `src/theme.ts`. Use these when a
 * raw color string is needed (inline styles, sx values, files without access to
 * the MUI theme) instead of hardcoding hex literals across the codebase.
 */
export const BRAND_COLORS = {
  primary: "#2563eb",
  primaryDark: "#1d4ed8",
  primaryLight: "#3b82f6",
  error: "#ef4444",
  errorDark: "#dc2626",
} as const;
